import Story from "./Story"
import Translation from "./Translation"

export default function ExperienceStories({ stories, skills }) {	
    return (
        <div className="stories">
            <div className="legend-block">
                <span className="legend">{ Translation("Expériences") }</span>
                <span className="legend-detail">({ Translation("du plus récent au plus ancien")})</span>
            </div>
            <div className="wrapper">
                {
                    stories.filter((story) => story.story.display === undefined ? true : story.story.display).map((story, i) => {
                        return (
                            <Story 
                                tags={ story.story.tags } 
                                description={ story.story.description }
                                title={ story.story.title }
                                project={ story.project }
                                company={ story.company }
                                skills={ skills }
                                key={i}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}